module.exports = __webpack_public_path__ + "static/media/tianying11.13a5896e.png";